import { ROOT } from '../../constants/links'

const redirect = (url = ROOT) => window.location.assign(url)

export default redirect
